import * as intercom from "./intercom/client";
import * as stats from "./stats/client";
import * as console from "./console/client";

export default [intercom, stats, console];
